//#region libraries
import React, { useEffect, useState } from "react";

//tremor
import { Flex, Title } from "@tremor/react";

//bootstrap
import { Row, Col } from "react-bootstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
  selectApprovedEmployee,
  getEmployeeList,
  selectTimelineApprovedEmployee,
  resetAssignEmployeesWorkZoneFlags,
  selectAssignEmployeesWorkZoneStatus,
  selectRemoveWorkzoneEmployeesStatus,
  resetRemoveWorkzoneEmployeesFlags
} from "_redux/slices/timeline/employees";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { selectSelectedTimeline } from "_redux/slices/timeline/timeline-areas";

//custom components
import EmployeesListCard from "./employees-list-card";
import { searchEmployeeName } from "_utils/functions";
import { Title as CustomTitle, NewScreen } from "_atoms";

//styles
import { Colors } from "_styles";
//#endregion

const EmployeeSettings = () => {

  //#region redux
  const dispatch = useDispatch();

  const dbUser = useSelector(selectFirebaseInfo);
  const approvedEmployees = useSelector(selectApprovedEmployee);
  const timelineApprovedEmployees = useSelector(selectTimelineApprovedEmployee);
  const selectedTimeline = useSelector(selectSelectedTimeline);
  const assignEmployeesWorkZoneStatus = useSelector(selectAssignEmployeesWorkZoneStatus);
  const removeWorkzoneEmployeesStatus = useSelector(selectRemoveWorkzoneEmployeesStatus);
  //#endregion

  //#region states
  const [currentEmployees, setCurrentEmployees] = useState(approvedEmployees)
  const [subtitle, setSubtitle] = useState("");
  //#endregion

  //#region use effects

  // on render use effect get employee list
  useEffect(() => {
    // get the list of employees from the database
    dispatch(getEmployeeList(dbUser.details.authority));
  }, []);

  useEffect(() => {
    setCurrentEmployees(approvedEmployees);

  }, [approvedEmployees]);

  // on employee assignmnt change, reset the employee list
  useEffect(() => {
    // if successfully assigned workzone, reset the employee list
    if (assignEmployeesWorkZoneStatus == "succeeded" || removeWorkzoneEmployeesStatus == "succeeded") {
      dispatch(getEmployeeList(dbUser.details.authority));
      dispatch(resetAssignEmployeesWorkZoneFlags());
      dispatch(resetRemoveWorkzoneEmployeesFlags());
    }
  }, [assignEmployeesWorkZoneStatus, removeWorkzoneEmployeesStatus]);

  // update  timeline subtitle depend on type
  useEffect(() => {
    if (selectedTimeline) {
      let subtitle = "";
      if (selectedTimeline.international) {
        subtitle += " International";
      } else {
        subtitle += " Domestic";
      }
      if (selectedTimeline.departures) {
        subtitle += " Departures";
      } else {
        subtitle += " Arrivals";
      }
      setSubtitle(subtitle);
    }
  }, [selectedTimeline]);

  //#endregion

  //#region functions

  // handle search for employee
  const handleSearch = (searchValue) => {

    let searchResult = [];

    // for each employee in the approved employees list, search for the search value
    Array.isFullArray(approvedEmployees) && approvedEmployees.forEach(employee => {
      // match employee name in timeline with search term
      let result = searchEmployeeName(employee, searchValue)

      // search term matches employee name, add to list
      if (result) {
        searchResult.push(employee)
      }
    })

    // set current employee list to match search term results
    setCurrentEmployees(searchResult);

  }

  // timeline title + subtitle for top of page
  const TimeLineTitle = () => {
    return (
      <Row >
        <Flex>
          <div>
            <p style={{ fontSize: 14, color: Colors.PRM_LIGHT_BLUE, marginBottom: -4 }}> {subtitle} </p>
            <Title> {selectedTimeline?.title ? selectedTimeline?.title : ""} </Title>
          </div>
        </Flex>
      </Row>
    )
  }
  //#endregion

  return (
    <NewScreen>

      {/* title & subtitle */}
      <Row>
        <Col>
          <CustomTitle
            name="Time Line Control Panel"
            subtitle={"Time Line Control Panel"}
            description={"Time line settings, Add, Approve, deny and block employee accounts"}
          />
        </Col>
      </Row>

      {/* timeline title  */}
      <TimeLineTitle />

      {/* list of all employees */}
      <Row className="mt-3" >
        <EmployeesListCard listTitle={"All Employees"} approvedEmployee={true} employees={currentEmployees} assigningEmployee={true} handleSearch={handleSearch} />
      </Row>

      {/* employees of selected timeline*/}
      <Row className="mt-3">
        <EmployeesListCard listTitle={selectedTimeline?.title ? selectedTimeline?.title + " " + "Employees" : "TimeLine Employees"} assignedEmployees={true} employees={timelineApprovedEmployees} />
      </Row>

    </NewScreen>
  );
};

export default EmployeeSettings;
